import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { makeStyles, Box, ButtonBase, InputBase } from '@material-ui/core';
import _, { isArray } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Prompt } from 'react-router-dom';
import { DropDownIcon, DropUpIcon } from '../../../../components/Icon';
import { teleVisitAPI } from '../../../../apis';
import StyleButton from '../../../../components/StyleButton';
import { i18n } from '../../../../language';
import { authNameE } from '../../../../utils/userFuncs';
import LongRemark from '../../../../components/LongRemark';
import { SET_EDIT, SET_UNEDIT } from '../../../../redux/constant';

const useStyle = makeStyles(() => ({
  root: {
    paddingTop: '1.875rem',
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    color: '#333333',
    marginBottom: '1.625rem',
    display: 'flex',
    alignItems: 'center',
  },
  textTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#538fff',
  },
  textContent: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    color: '#2e4469',
  },
  dropBtn: {
    width: '1.5rem',
    height: '1.5rem',
  },
  dropIcon: {
    fontSize: '0.66rem',
    color: '#231f20',
  },
  tableTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  tableContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: '#2e4469',
    display: 'flex',
    height: '3.5rem',
    alignItems: 'center',
  },
  tableInput: {
    width: '20rem',
    height: '3.5rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: '#2e4469',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    padding: '0 1rem',
    '&.Mui-disabled': {
      color: '#2e4469',
    },
  },
  time: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
}));

const Mapping = () => {
  const classes = useStyle();
  const [list, setList] = useState([]);
  const [dropdownFlag, setDropdownFlag] = useState([]);
  const roleMap = useSelector((state) => state.roleMap);
  const dispatch = useDispatch();
  const editFlag = useSelector((state) => state.dutyEditFlag);

  const getMappingList = useCallback(async () => {
    try {
      const { result } = await teleVisitAPI.getTelevisitMappingList();

      setList(
        _.map(result, (item) => ({
          ...item,
          physicalBedNo: item.physicalBedNo ?? `${item.ccWardCode}bed${item.bedNo}`,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getMappingList();
    })();
  }, [getMappingList]);

  const dataMemo = useMemo(() => {
    if (isArray(list)) {
      let wardGroup = _.sortBy(
        _.groupBy(list, (item) => `${item.ccHospitalCode} + ${item.ccWardLocation}`),
        (item) => item[0].ccHospitalCode
      );

      let temp = _.map(wardGroup, (locationItem) => {
        locationItem.sort((a, b) => {
          let value1 = a.ccWardCode;
          let value2 = b.ccWardCode;
          if (value1 === value2) {
            return a.bedNo - b.bedNo;
          }
          return value2 - value1;
        });

        return locationItem;
      });

      // Init dropdown
      setDropdownFlag((oldData) => {
        if (oldData > 0) {
          return oldData;
        }

        let tempIndex = 0;
        let tempFlag = [];
        while (tempIndex < temp.length) {
          tempFlag.push(true);
          tempIndex++;
        }
        return tempFlag;
      });

      return temp;
    }

    return [];
  }, [list]);

  const handleInputPhysicalBedNumber = useCallback(
    (wardCode, bedNo) => (event) => {
      dispatch({ type: SET_EDIT });
      setList((oldData) => {
        let temp = [...oldData];
        const inputIndex = _.findIndex(oldData, (item) => item.ccWardCode === wardCode && item.bedNo === bedNo);

        temp[inputIndex].physicalBedNo = event.target.value;

        return [...temp];
      });
    },
    []
  );

  const handleDropdown = useCallback(
    (index) => () => {
      setDropdownFlag((oldData) => {
        let temp = [...oldData];
        temp[index] = !temp[index];
        return temp;
      });
    },
    []
  );

  const handleSave = useCallback(async () => {
    try {
      await teleVisitAPI.saveTelevisitMapping({ mapping: list });
      dispatch({ type: SET_UNEDIT });
      (async () => {
        await getMappingList();
      })();
    } catch (error) {
      console.log(error);
    }
  }, [list, getMappingList]);

  return (
    <div className={classes.root}>
      <Prompt
        when={editFlag}
        message={JSON.stringify({
          header: i18n.t('DUTYASSIGN_NOT_SAVE_TITLE'),
          content: i18n.t('DUTYASSIGN_NOT_SAVE_BODY'),
        })}
      />

      <div className={classes.title}>
        {i18n.t('TELEVISIT_SETTING_MAPPING_TITLE')}
        <LongRemark
          content={<div dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_SETTING_MAPPING_TITLE_REMARK') }} />}
        />
      </div>
      {roleMap[authNameE.setting_televisit_mapping_save_btn] && (
        <div className={classes.time} style={{ color: dataMemo[0]?.[0]?.createdAt ? '#7d86a9' : '#f44336' }}>
          {dataMemo[0]?.[0]?.createdAt
            ? i18n.t('SETTING_TELEVISIT_MAPPING_SAVE_ON', {
                value: moment(dataMemo[0][0].createdAt).format('yyyy-MM-DD HH:mm'),
              })
            : i18n.t('SETTING_TELEVISIT_MAPPING_NOT_SAVE')}
        </div>
      )}
      {dataMemo.map((wardItem, wardIndex) => (
        <Box
          display="flex"
          flexDirection="column"
          p="1.25rem 0"
          borderBottom="solid 1px #d9d9d9"
          width="fit-content"
          key={`${wardItem[0].ccHospitalCode} - ${wardItem[0].ccWardLocation}`}
        >
          {/* head */}
          <Box display="flex" alignItems="center" gridColumnGap="1.875rem">
            <Box display="flex" flexDirection="column" gridRowGap="0.313rem" width="10rem">
              <div className={classes.textTitle}>{i18n.t('TELEVISIT_SETTING_MAPPING_HOSPITAL_CODE')}</div>
              <div className={classes.textContent}>{wardItem[0].ccHospitalCode}</div>
            </Box>
            <Box display="flex" flexDirection="column" gridRowGap="0.313rem" width="10rem">
              <div className={classes.textTitle}>{i18n.t('TELEVISIT_SETTING_MAPPING_WARD_LOCATION')}</div>
              <div className={classes.textContent}>{wardItem[0].ccWardLocation}</div>
            </Box>
            <Box display="flex" justifyContent="flex-end" alignItems="center" width="20rem" height="3.5rem">
              <ButtonBase className={classes.dropBtn} onClick={handleDropdown(wardIndex)}>
                {dropdownFlag[wardIndex] ? (
                  <DropUpIcon className={classes.dropIcon} />
                ) : (
                  <DropDownIcon className={classes.dropIcon} />
                )}
              </ButtonBase>
            </Box>
          </Box>
          {/* body */}
          {dropdownFlag[wardIndex] && (
            <Box display="flex" flexDirection="column" mt="1.875rem" gridRowGap="0.625rem">
              <Box display="flex" gridColumnGap="1.875rem">
                <Box className={classes.tableTitle} width="10rem">
                  {i18n.t('TELEVISIT_SETTING_MAPPING_WARD_CODE')}
                </Box>
                <Box className={classes.tableTitle} width="10rem">
                  {i18n.t('TELEVISIT_SETTING_MAPPING_BED_NUMBER')}
                </Box>
                <Box className={classes.tableTitle} width="20rem">
                  {i18n.t('TELEVISIT_SETTING_MAPPING_PHYSICAL_BED_NUMBER')}
                </Box>
              </Box>
              {wardItem.map((item) => (
                <Box display="flex" gridColumnGap="1.875rem" key={`${item.ccWardCode} - ${item.bedNo}`}>
                  <Box className={classes.tableContent} width="10rem">
                    {item.ccWardCode}
                  </Box>
                  <Box className={classes.tableContent} width="10rem">
                    {item.bedNo}
                  </Box>
                  <InputBase
                    className={classes.tableInput}
                    value={item.physicalBedNo}
                    onChange={handleInputPhysicalBedNumber(item.ccWardCode, item.bedNo)}
                    disabled={!roleMap[authNameE.setting_televisit_mapping_save_btn]}
                    inputProps={{ maxLength: 60 }}
                  />
                </Box>
              ))}
            </Box>
          )}
        </Box>
      ))}
      {dataMemo.length > 0 && (
        <Box display="flex" justifyContent="flex-end" p="1.875rem 0" width="43.5rem">
          {roleMap[authNameE.setting_televisit_mapping_save_btn] && (
            <StyleButton type="fill" width="7.25rem" text={i18n.t('SETTING_SAVE')} onClick={handleSave} />
          )}
        </Box>
      )}
    </div>
  );
};

export default Mapping;
